import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { showToast } from "utils/utility";
import { usePagination } from "hook/usePagination";
import { useFlightCommissionData } from "libs/data-access";
import { IFlightCommissionResponse } from "libs/data-access/types";

export default function useCommissionB2B() {

    const navigate = useNavigate();

    const {
        getFlightCommissionData,
        patchFlightCommissionData
    } = useFlightCommissionData();


    const {
        dataList: flightCommissionList,
        setDataList,
        isLoading,
        // setSearchText,
        // searchText,
        goToNextPage,
        goToPreviousPage,
        disablePrev,
        disableNext,
        // initialLoading,
        // setTriggerNextPage,
        // setTriggerPreviousPage,
    } = usePagination<IFlightCommissionResponse>({
        fetchListData: getFlightCommissionData,
        maxLimit: 100,
        // sortby: "id",
        sortingOrder: "DESC",
        // extraQueryParams: queryParams as Record<string, string | number | boolean>,
        // paginationParams: paginationQueryParams as Record<string, string | number | boolean>,
        dependencies: []
    });

    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const [isUpdatingStatus, setIsUpdatingStatus] = useState<boolean>(false);


    // API CALLS
    const updateCommissionStatus = async (commission: IFlightCommissionResponse) => {

        setIsUpdatingStatus(true);

        const response = await patchFlightCommissionData(`/${commission.id}/${commission.status ? "inActive" : "active"}`);

        if (response.isSuccess) {
            // console.log("Response for saving commission: ", response.data);

            const data = flightCommissionList;
            const formattedData = data.map(each => each.id === commission.id ? { ...each, status: response.data?.data?.status } : each);

            setDataList(formattedData);
        } else {
            console.log("Error while saving commission: ", response);
            showToast({
                type: "error",
                message: response.message || "Error while saving commission",
            });
        };

        setIsUpdatingStatus(false);

    };


    return {
        navigate,
        isLoading,
        goToNextPage,
        goToPreviousPage,
        disablePrev,
        disableNext,
        flightCommissionList,
        expandedIndex,
        setExpandedIndex,
        isUpdatingStatus,
        updateCommissionStatus
    };

}